import React from "react";
import styles from "./moreOption.module.css";
import { Typography } from "@mui/material";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import {
  AtSign,
  Award,
  BarChart2,
  Bell,
  Calendar,
  CreditCard,
  DollarSign,
  File,
  FileText,
  Flag,
  Folder,
  Key,
  Layers,
  List,
  LogOut,
  MessageSquare,
  Pocket,
  Search,
  Send,
  Sliders,
  Tablet,
  User,
  UserCheck,
  Users,
} from "react-feather";
import { communicationChatBoxOpen } from "../../redux/actions/communicationChatBoxAction";
import { useDispatch, useSelector } from "react-redux";
import { AddModeratorOutlined, DirectionsCarFilledOutlined } from "@mui/icons-material";
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
const Prospect = () => {
  const dispatch = useDispatch();
  const isCommunicationChatBoxOpen = useSelector(
    (store) => store.communicationChatBoxReducer
  );

  const communicationChatBoxHandler = () => {
    dispatch(communicationChatBoxOpen(!isCommunicationChatBoxOpen));
  };

  return (
    <React.Fragment>
      <Helmet title="More Option" />

      <div className={`${styles.pageTitleWrap}`}>
        <Typography display="inline" className={`${styles.pageTitle}`}>
          More
        </Typography>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            People
          </Typography>
          <div
            className={`${styles.OptionCard}`}
            onClick={(e) => localStorage.removeItem("prospectPageState")}
          >
            <Link
              to={"/people/leaderboards"}
              className={`${styles.OptionCardUnder}`}
            >
              <Award />
              <p>Leaderboard</p>
            </Link>
          </div>
          <div
            className={`${styles.OptionCard}`}
            onClick={(e) => localStorage.removeItem("prospectPageState")}
          >
            <Link
              to={"/people/prospects"}
              className={`${styles.OptionCardUnder}`}
            >
              <UserCheck />
              <p>Prospect</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/people/tenants"}
              className={`${styles.OptionCardUnder}`}
            >
              <User />
              <p>Tenant</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/people/users"} className={`${styles.OptionCardUnder}`}>
              <Users />
              <p>User</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/people/contacts"} className={`${styles.OptionCardUnder}`}>
              <Send />
              <p>Contacts</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography variant="button" display="block" className={`${styles.MoreCateTitle}`}>Email Campaigns</Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/campaign/groups"} className={`${styles.OptionCardUnder} ${styles.Active}`}>
              <Pocket />
              <p>Manage Email Groups</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/campaign/campaigns"} className={`${styles.OptionCardUnder} ${styles.Active}`}>
              <AtSign />
              <p>Manage Campaign</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/campaign/analytics"} className={`${styles.OptionCardUnder} ${styles.Active}`}>
              <BarChart2 />
              <p>Email Analytics</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Request
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/cases/maintenance-request"}
              className={`${styles.OptionCardUnder}`}
            >
              <Calendar />
              <p>Maintenance</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/cases/tasks"}
              className={`${styles.OptionCardUnder}`}
            >
              <List />
              <p>Tasks</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Communication
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/schedule"} className={`${styles.OptionCardUnder}`}>
              <Calendar />
              <p>Schedule</p>
            </Link>
          </div>
          <div
            className={`${styles.OptionCard}`}
            onClick={communicationChatBoxHandler}
          >
            <span className={`${styles.OptionCardUnder}`}>
              <MessageSquare />
              <p>Chat</p>
            </span>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Operations
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/leases"} className={`${styles.OptionCardUnder}`}>
              <FileText />
              <p>Leases</p>
            </Link>
          </div>
          {/* <div className={`${styles.OptionCard}`}>
            <Link to={"/income/all-income"} className={`${styles.OptionCardUnder}`}>
              <CreditCard />
              <p>Payments</p>
            </Link>
          </div> */}
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography variant="button" display="block" className={`${styles.MoreCateTitle}`}>Income</Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/income/all-income"} className={`${styles.OptionCardUnder}`}>
              <DollarSign />
              <p>All Income</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/income/income-category"} className={`${styles.OptionCardUnder}`}>
              <Layers />
              <p>Income Category</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography variant="button" display="block" className={`${styles.MoreCateTitle}`}>Expenses</Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/expense/all-expense"} className={`${styles.OptionCardUnder}`}>
              <CreditCard />
              <p>All Expenses</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/expense/manage-payee"} className={`${styles.OptionCardUnder}`}>
              <Sliders />
              <p>Manage Payee</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/expense/expense-category"} className={`${styles.OptionCardUnder}`}>
              <Layers />
              <p>Expense Category</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Smart Devices
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/smart-devices/list"}
              className={`${styles.OptionCardUnder}`}
            >
              <Tablet />
              <p>Manage Devices</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/smart-devices/keyfobs"}
              className={`${styles.OptionCardUnder}`}
            >
              <Key />
              <p>Manage Keyfob</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/smart-devices/alerts"}
              className={`${styles.OptionCardUnder}`}
            >
              <Bell />
              <p>Device Alerts</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Security
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/security/vehicle/list"} className={`${styles.OptionCardUnder}`}>
              <DirectionsCarFilledOutlined />
              <p>Vehicles</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/security/journal/list"} className={`${styles.OptionCardUnder}`}>
              <AddModeratorOutlined />
              <p>Journals</p>
            </Link>
          </div> 
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Pets
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/pet/list"} className={`${styles.OptionCardUnder}`}>
              <PetsOutlinedIcon />
              <p>Pets</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Resources
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/resources/knowledge-bases"}
              className={`${styles.OptionCardUnder}`}
            >
              <File />
              <p>Knowledge Base</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/resources/knowledge-base-categories"}
              className={`${styles.OptionCardUnder}`}
            >
              <Folder />
              <p>Knowledge Base Category</p>
            </Link>
          </div>
          <div className={`${styles.OptionCard}`}>
            <Link
              to={"/resources/community-boards"}
              className={`${styles.OptionCardUnder}`}
            >
              <Flag />
              <p>Community Board</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.MoreList}`}>
          <Typography
            variant="button"
            display="block"
            className={`${styles.MoreCateTitle}`}
          >
            Logs
          </Typography>
          <div className={`${styles.OptionCard}`}>
            <Link to={"/logs"} className={`${styles.OptionCardUnder}`}>
              <Search />
              <p>Logs</p>
            </Link>
          </div>
        </div>
        <div className={`${styles.OptionCardFull}`}>
          <Link to={"/logout"} className={`${styles.OptionCardUnderFull}`}>
            <LogOut />
            <p>Logout</p>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Prospect;
